module.exports = __webpack_public_path__ + "static/media/icon-excel.93a59146.png";